'use client';

import { IBlogResponse } from '@sapientpro/sapientpro-data-models';
import { useAtomValue } from 'jotai';
import styles from './Blog.module.scss';
import BlogHead from './BlogHead/BlogHead';
import { blogSearch } from '../../store/blogFilters';
import ArticlesList from './ArticlesList/ArticlesList';
import CategoriesSection from './CategoriesSection/CategoriesSection';
import ContactModal from '../../components/ContactModal';
import GradientCircles from '../../components/GradientCircles';

const Blog = ({ data }: { data: IBlogResponse }) => {
  const search = useAtomValue(blogSearch);
  const isSearching = !!search;

  return (
    <main className={styles.blog}>
      <BlogHead data={data} />
      {!isSearching && <CategoriesSection categories={data.categoriesWithPosts} />}
      {isSearching && <ArticlesList filters={{ search }} />}
      <section>
        <ContactModal isBlockView />
        <GradientCircles />
      </section>
    </main>
  );
};

export default Blog;
